const CACHE_KEY = process.env.REACT_APP_CACHE_KEY || 'github_repo_cache';
const CACHE_DURATION = parseInt(process.env.REACT_APP_CACHE_DURATION) || (30 * 60 * 1000); // 30 minutes
const MAX_CACHE_SIZE = parseInt(process.env.REACT_APP_MAX_CACHE_SIZE) || (2 * 1024 * 1024); // 2MB limit

export const saveToCache = (data) => {
  try {
    // Only cache essential structure, not all files
    const essentialData = {
      timestamp: Date.now(),
      repoStructure: data.repoStructure,
      loadedPaths: Array.from(data.loadedPaths || []),
      recentFiles: data.allFiles ? data.allFiles.slice(-50) : [], // Only keep 50 most recent files
      rateLimitRemaining: data.rateLimitRemaining,
      rateLimitReset: data.rateLimitReset
    };

    const cacheString = JSON.stringify(essentialData);

    // Check if cache size exceeds limit
    if (cacheString.length * 2 > MAX_CACHE_SIZE) { // *2 for unicode characters
      console.warn('Cache too large, storing minimal data');
      const minimalData = {
        timestamp: Date.now(),
        repoStructure: {
          name: data.repoStructure?.name || 'Repository',
          type: 'folder',
          children: data.repoStructure?.children ? Object.keys(data.repoStructure.children).reduce((acc, key) => {
            acc[key] = {
              name: key,
              type: 'folder',
              children: {},
              loaded: false
            };
            return acc;
          }, {}) : {}
        },
        rateLimitRemaining: data.rateLimitRemaining,
        rateLimitReset: data.rateLimitReset
      };
      localStorage.setItem(CACHE_KEY, JSON.stringify(minimalData));
    } else {
      localStorage.setItem(CACHE_KEY, cacheString);
    }

    console.log(`Cache saved: ${(cacheString.length / 1024).toFixed(2)} KB`);
  } catch (error) {
    console.warn('Failed to save to cache:', error);
    // Clear cache if storage quota exceeded
    if (error.name === 'QuotaExceededError') {
      localStorage.removeItem(CACHE_KEY);
      console.warn('Storage quota exceeded, cleared cache');
    }
  }
};

export const loadFromCache = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return null;

    const cacheData = JSON.parse(cached);
    const age = Date.now() - cacheData.timestamp;

    if (age > CACHE_DURATION) {
      localStorage.removeItem(CACHE_KEY);
      console.log('Cache expired, clearing');
      return null;
    }

    const cacheSize = (cached.length / 1024).toFixed(2);
    console.log(`Cache loaded: ${cacheSize} KB, Age: ${Math.round(age / 1000 / 60)} minutes`);

    return {
      repoStructure: cacheData.repoStructure,
      allFiles: cacheData.recentFiles || cacheData.allFiles || [],
      loadedPaths: new Set(cacheData.loadedPaths || []),
      rateLimitRemaining: cacheData.rateLimitRemaining || 60,
      rateLimitReset: cacheData.rateLimitReset
    };
  } catch (error) {
    console.warn('Failed to load from cache:', error);
    localStorage.removeItem(CACHE_KEY);
    return null;
  }
};

export const clearCache = () => {
  localStorage.removeItem(CACHE_KEY);
  console.log('Cache cleared');
};